// extracted by mini-css-extract-plugin
export default {"WebhookConfigMenu-label":"WebhookConfigMenu-label13-dYwEvDTQV","WebhookConfigMenu-description":"WebhookConfigMenu-description2bzqeQ3Cg576"};